import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";
import { format } from 'date-fns';
import { useTranslation } from "react-i18next";
import { convertApiHeaderToReactTableHeader } from "src/components/Common/UI/DndTable/UtilFunctions";
import { useGetAllAtms } from "../api/getAllAtms";
import { useGetAtmDownloadExcel } from "../api/getAtmDownloadExcel";


// All your logic is here
export const useAtmsDataViewLogic = () => {
  const { activeFilters } = useContext(SydFilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({action: "",selectedRows: [],});
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetAtm["data"]>([]);
  const getAllAtmsQuery = useGetAllAtms({data: activeFilters as IAtmSearchForm});
  const atmDownloadExcelMutation = useGetAtmDownloadExcel({data: activeFilters as IAtmSearchForm});
  const downloadAnchorRef = useRef<HTMLAnchorElement>(null);
  
  const { t } = useTranslation();

  const loadingDone = [getAllAtmsQuery].every(({ isFetching }) => !isFetching);

  const errorData = [getAllAtmsQuery].filter(({ isError }) =>isError ? true : false);

  let canDownloadExcel = false;

  if(getAllAtmsQuery.data){
    canDownloadExcel = getAllAtmsQuery.data?.data.length > 0;
  }

  const dataTypes = [
    { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
    { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
    { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
    { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "YYYY-MM-DD HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
    { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
    { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
    { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
    { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "seconds" },
    { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" }
  ];

  const data = getAllAtmsQuery.data ? getAllAtmsQuery.data.data : [];
  const apiTotalRecords = getAllAtmsQuery.data ? getAllAtmsQuery.data.totalRercords : 0;

  const columnData = [
    {
      columnName: "id",
      columnDisplayName: "ID",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "Number",
    },
    {
      columnName: "description",
      columnDisplayName: "Περιγραφή",
      visible: true,
      columnOrder: 2,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "unID",
      columnDisplayName: "Μονάδα",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "atmTerm",
      columnDisplayName: "Κωδικός ΑΤΜ",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "lineType",
      columnDisplayName: "Είδος Γραμμής",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnDataType: "String",
    },
    
  ]

  const columns = useMemo(() => {
    console.log("columnData",columnData)
    return convertApiHeaderToReactTableHeader(
      columnData ,
      dataTypes
    );
  }, []);

  const closeActionModal = () => {
    setModalEvent({ action: "", selectedRows: [] });
  };

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία ATM");
        break;
      case "edit":
        title = t("Επεξεργασία ATM");
        break;
      case "delete":
        title = t("Διαγραφή ATM");
        break;
      case "showDetails":
        title = t("Λεπτομέρειες");
        break;   
      default:
        break;
    }
    return title;
  };

   const downloadFile = (blobString: string, reportName: string, fileExtension: string) => {
      if (downloadAnchorRef.current) {
        const recordingsBlob = new Blob([blobString], { type: 'application/octet-stream' });
        const recordingsBlobURL = URL.createObjectURL(recordingsBlob);
  
        const currentDate: Date = new Date();
        const nowDateFormated: string = format(currentDate, 'yyyy-MM-dd_HH-mm-ss');
        const fileName:string = `${reportName}_${nowDateFormated}.${fileExtension}`;
  
        downloadAnchorRef.current.href = recordingsBlobURL;
        downloadAnchorRef.current.download = fileName;
        downloadAnchorRef.current.click();
      }
    }

    const DownloadExcel = async () => {
    atmDownloadExcelMutation.mutateAsync({data: activeFilters as IAtmSearchForm})
    .then((apiRecordingsExcelResponse) => {
      downloadFile(apiRecordingsExcelResponse, "Atm", "xlsx");
    }).catch((error) => {
      console.log(error)
    })
  }

  const actionEvent = async (event: IEvent) => {
    switch (event.action) {
      case "downloadExcel":
        await DownloadExcel();
        break;
      default:
        const selectedRows: number[] = selectedRowsOfTable[0]
        ? [...[selectedRowsOfTable[0].id]]
        : [];
        setModalEvent({ action: event.action, selectedRows: selectedRows });
    }
   
  };

  useEffect(() => {
    setSelectedRowsOfTable([]);
    getAllAtmsQuery.refetch();
  }, [activeFilters]);

  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    apiTotalRecords,
    canDownloadExcel,
    downloadAnchorRef
  };
};
